export const convert2Array = <T extends any>(param: T | T[]): T[] =>
  param ? (Array.isArray(param) ? param : [param]) : [];
